import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../api/axios';

const SettingsContext = createContext();

const defaultSettings = {
  siteName: 'Hospitex',
  tagline: "Pakistan's Leading Medical Equipment Supplier",
  phone: '+92 335 555 4828',
  email: 'hospitex@gmail.com',
  whatsapp: '+923355554828',
  address: 'Lahore, Punjab, Pakistan',
  socialLinks: { facebook: '#', instagram: '#', youtube: '#' },
  shipping: { freeShippingThreshold: 5000, defaultShippingCost: 300 },
  announcement: '',
  showAnnouncement: false,
  currency: 'PKR',
  currencySymbol: '₨',
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);

  useEffect(() => {
    API.get('/settings')
      .then(({ data }) => setSettings({ ...defaultSettings, ...data }))
      .catch(() => {});
  }, []);

  const refreshSettings = () => {
    API.get('/settings').then(({ data }) => setSettings({ ...defaultSettings, ...data })).catch(() => {});
  };

  return (
    <SettingsContext.Provider value={{ settings, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
